import { useEffect, useState } from 'react';
import Multiselect from "react-widgets/Multiselect";
import styled from '@emotion/styled';
import { useTheme } from "@mui/material";


export const MultiSelectWrapperStyled = styled.div`
  .rw-multiselect-tag {
    background-color: ${({ main }) => main};
    border: 1px solid ${({ main }) => main};
    color: white;
  }
  .rw-state-focus .rw-widget-picker.rw-widget-input {
    box-shadow: 0px 0px 0px 3px rgba(${({ mainRGB }) => mainRGB}, 0.25);
   }
  .rw-state-focus .rw-widget-picker {
    border-color: ${({ main }) => main};
  }
`;


const MultiOptionSelect = (props) => {
  const { id, name, type, typeName, order, values, input: { onChange }, required } = props;

  const { palette } = useTheme();
  const { primary: { contrastText, main, mainRGB } } = palette;

  const [options] = useState(values);
  const [value, setValue] = useState();

  const changeHandler = (changeValues) => {
    if (changeValues?.length > 0) {
      setValue(changeValues.map(val => val.id));
      // return onChange(changeValues);
      return onChange({
        id,
        typeName,
        order,
        result: changeValues
      });
    }
    if (!required) {
      setValue([]);
      // return onChange([]);
      return onChange({
        id,
        typeName,
        order,
        result: []
      });
    }
  }

  useEffect(() => {
    const selectedOptions = [];
    const selectedValues = [];

    if (options && options.length > 0) {
      for (let option of options) {
        if (option.default) {
          selectedValues.push(option.id);
          selectedOptions.push(option);
        }
      }

      if (selectedValues?.length > 0) {
        // onChange(selectedOptions); 
        onChange({
          id,
          typeName,
          order,
          result: selectedOptions
        });
        setValue(selectedValues);
      }
    }
  }, []);

  return (
    <MultiSelectWrapperStyled main={main} mainRGB={mainRGB}>
      <Multiselect
        // defaultValue={defaultValue}
        value={value}
        dataKey="id"
        textField="label"
        onChange={(changeValues) => { changeHandler(changeValues) }}
        data={options}
      />
    </MultiSelectWrapperStyled>
  )
}

export default MultiOptionSelect;